// extracted by mini-css-extract-plugin
export default {"header":"Header_header__sh7UA","title":"Header_title__h06yP","menu":"Header_menu__5dLuN","menuElement":"Header_menuElement__MP0eE"};